import './EditWidgetModal.css';

import React, { useState, useEffect, useContext } from 'react';
import B2BPopUpForm from '../../b2b-common/B2BPopUpForm';
import WidgetCellSelector from '../components/WidgetCellSelector';
import { LoginContext } from '../../../App';
import { B2BContentContext } from '../../layout/Layout';
import { updateWidget } from '../../../services/b2b-reporting-apiServices';
import { showNotification } from '../../b2b-common/Notification';
import EditText from '../../b2b-common/EditText';
import { Clear } from '@mui/icons-material';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';

export const WidgetSizeSelector = ({ widget, setWidget, readOnly = false }) => {
    const { t } = useB2BTranslation('b2b-reporting');
    return (
        <div className="widget-size-selector">
            <EditText object={widget} objectField={'widgetConfig.width'}
                setObjectField={setWidget} label={t('Width')}
                className={'widget-width'} suffix={t('columns')} type='number'
                readOnly={readOnly}
                minValue={1}
            />
            <Clear />
            <EditText object={widget} objectField={'widgetConfig.height'}
                setObjectField={setWidget} label={t('Height')}
                className={'widget-heigth'} suffix={t('rows')} type='number'
                readOnly={readOnly}
                minValue={1}
            />
        </div>
    );
};

const EditWidgetModal = ({ dashboard, widget, open, onCancel, onSaved }) => {
    const [currentWidget, setCurrentWidget] = useState(widget);

    const { loginData } = useContext(LoginContext);
    const { setNotification } = useContext(B2BContentContext);
    const { t } = useB2BTranslation('b2b-reporting');

    useEffect(() => {
        if (widget && widget.widgetConfig) {
            setCurrentWidget(widget);
        }
    }, [widget]);

    if (!widget || !widget.widgetConfig) {
        return null; // or some fallback UI
    }

    const handleSelectedCell = (cell) => {
        setCurrentWidget(prevWidget => ({
            ...prevWidget,
            widgetConfig: {
                ...prevWidget.widgetConfig,
                row: cell.row,
                column: cell.col
            }
        }));
    }

    const handleUpdateWidget = async () => {
        try {
            const updatedWidget = await updateWidget(loginData.accessToken, loginData.loggedOrganizationUuid, dashboard.dashboardId, currentWidget);
            showNotification(setNotification, t('Widget updated'), 'success', 3000);
            onSaved && onSaved(updatedWidget);
        } catch (error) {
            showNotification(setNotification, t('Error updating widget: ') + error.message, 'error', 3000);
        }
    }

    return (
        <B2BPopUpForm
            open={open}
            title={t('Edit Widget')}
            onClose={onCancel}
            className="edit-widget-modal"
            buttons={
                [
                    {
                        label: t('Update widget'),
                        confirm: true,
                        onConfirm: handleUpdateWidget
                    },
                    {
                        label: t('Cancel'),
                        onClick: onCancel
                    }
                ]
            }
        >
            <WidgetSizeSelector widget={currentWidget} setWidget={setCurrentWidget} />
            <WidgetCellSelector dashboard={dashboard} widget={currentWidget} onSelectedCell={handleSelectedCell} />
        </B2BPopUpForm>
    );
};

export default EditWidgetModal;